var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthSafety(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "home-health-safety-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HK---Inventory",
    transform: "translate(-40.000000, -658.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Document-Manual-Card-Copy-5",
    transform: "translate(16.000000, 634.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home-health-safety-icon",
    transform: "translate(24.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9744936,0.255791541 L30.9744936,8.13873795 C31.6076275,8.49523516 32,9.1695972 32,9.90125355 L32,29.9816929 C32,31.0963731 31.1045695,32 30,32 L2,32 C0.8954305,32 0,31.0963731 0,29.9816929 L0,9.90125355 C0,9.1695972 0.392372467,8.49523516 1.02550641,8.13873795 L15.0255064,0.255791541 C15.6312159,-0.085263847 16.3687841,-0.085263847 16.9744936,0.255791541 Z M16,2.01830714 L2,9.90125355 L2,29.9816929 L30,29.9816929 L30,9.90125355 L16,2.01830714 Z M16,8.7894679 C17.6568542,8.7894679 19,10.1449082 19,11.8169286 L19,11.8169286 L19,14.844 L22,14.8443893 C23.5976809,14.8443893 24.9036609,16.1047414 24.9949073,17.6939637 L25,17.87185 C25,19.5438704 23.6568542,20.8993107 22,20.8993107 L22,20.8993107 L19,20.899 L19,23.9267714 C19,25.5390768 17.75108,26.8570112 16.1762728,26.9490928 L16,26.9542322 C14.3431458,26.9542322 13,25.5987918 13,23.9267714 L13,23.9267714 L13,20.899 L10,20.8993107 C8.40231912,20.8993107 7.09633912,19.6389587 7.00509269,18.0497363 L7,17.87185 C7,16.1998296 8.34314575,14.8443893 10,14.8443893 L10,14.8443893 L13,14.844 L13,11.8169286 C13,10.2046232 14.24892,8.88668887 15.8237272,8.79460721 Z M17,20.899 L15,20.899 L15,23.9267714 C15,24.4443016 15.3860402,24.8708418 15.8833789,24.9291357 L16,24.935925 C16.5522847,24.935925 17,24.4841116 17,23.9267714 L17,23.9267714 L17,20.899 Z M13,16.862 L10,16.8626965 C9.44771525,16.8626965 9,17.3145099 9,17.87185 C9,18.4291902 9.44771525,18.8810036 10,18.8810036 L10,18.8810036 L13,18.881 L13,16.862 Z M17,16.862 L15,16.862 L15,18.881 L17,18.881 L17,16.862 Z M22,16.8626965 L19,16.862 L19,18.881 L22,18.8810036 C22.5128358,18.8810036 22.9355072,18.4914298 22.9932723,17.9895387 L23,17.87185 C23,17.3145099 22.5522847,16.8626965 22,16.8626965 L22,16.8626965 Z M16,10.807775 C15.4477153,10.807775 15,11.2595885 15,11.8169286 L15,11.8169286 L15,14.844 L17,14.844 L17,11.8169286 C17,11.2993985 16.6139598,10.8728582 16.1166211,10.8145644 Z",
    id: "Combined-Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthSafety);
export default __webpack_public_path__ + "static/media/health-safety.9ddcb47065390780d4105bab657a3e98.svg";
export { ForwardRef as ReactComponent };